import { render, staticRenderFns } from "./distributionCard.vue?vue&type=template&id=a5d776ee&"
import script from "./distributionCard.vue?vue&type=script&lang=js&"
export * from "./distributionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports